import { createAction } from '@reduxjs/toolkit';
import { SelectCustomerLocation } from 'app/store/types/user-context-types';

// Action Creators
export const fetchUserContextStarted = createAction<undefined>('FETCH_USER_CONTEXT_STARTED');
export const fetchUserContextFulfilled = createAction<MinesiderBackend.UserContext>('FETCH_USER_CONTEXT_FULFILLED');
export const fetchUserContextFailed = createAction<undefined>('FETCH_USER_CONTEXT_FAILED');
export const changeCustomerLocation = createAction<undefined>('CHANGE_CUSTOMER_LOCATION');
export const selectCustomerLocation = createAction<SelectCustomerLocation>('SELECT_LOCATION');
